var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqlite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57,
    height: 20,
    role: "img",
    "aria-label": "sqlite",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sqlite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 57,
    height: 20,
    fill: "#07405e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPlNRTGl0ZTwvdGl0bGU+PHBhdGggZD0iTTIxLjY3OC41MjFjLTEuMDMyLS45Mi0yLjI4LS41NS0zLjUxMy41NDRhOC43MSA4LjcxIDAgMCAwLS41NDcuNTM1Yy0yLjEwOSAyLjIzNy00LjA2NiA2LjM4LTQuNjc0IDkuNTQ0LjIzNy40OC40MjIgMS4wOTMuNTQ0IDEuNTYxYTEzLjA0NCAxMy4wNDQgMCAwIDEgLjE2NC43MDNzLS4wMTktLjA3MS0uMDk2LS4yOTZsLS4wNS0uMTQ2YTEuNjg5IDEuNjg5IDAgMCAwLS4wMzMtLjA4Yy0uMTM4LS4zMi0uNTE4LS45OTUtLjY4Ni0xLjI4OS0uMTQzLjQyMy0uMjcuODE4LS4zNzYgMS4xNzYuNDg0Ljg4NC43NzggMi40Ljc3OCAyLjRzLS4wMjUtLjA5OS0uMTQ3LS40NDJjLS4xMDctLjMwMy0uNjQ0LTEuMjQ0LS43NzItMS40NjQtLjIxNy44MDQtLjMwNCAxLjM0Ni0uMjI2IDEuNDc4LjE1Mi4yNTYuMjk2LjY5OC40MjIgMS4xODYuMjg2IDEuMS40ODUgMi40NC40ODUgMi40NGwuMDE3LjIyNGEyMi40MSAyMi40MSAwIDAgMCAuMDU2IDIuNzQ4Yy4wOTUgMS4xNDYuMjczIDIuMTMuNSAyLjY1N2wuMTU1LS4wODRjLS4zMzQtMS4wMzgtLjQ3LTIuMzk5LS40MS0zLjk2Ny4wOS0yLjM5OC42NDItNS4yOSAxLjY2MS04LjMwNCAxLjcyMy00LjU1IDQuMTEzLTguMjAxIDYuMy05Ljk0NS0xLjk5MyAxLjgtNC42OTIgNy42My01LjUgOS43ODgtLjkwNCAyLjQxNi0xLjU0NSA0LjY4NC0xLjkzMSA2Ljg1Ny42NjYtMi4wMzcgMi44MjEtMi45MTIgMi44MjEtMi45MTJzMS4wNTctMS4zMDQgMi4yOTItMy4xNjZjLS43NC4xNjktMS45NTUuNDU4LTIuMzYyLjYyOS0uNi4yNTEtLjc2Mi4zMzctLjc2Mi4zMzdzMS45NDUtMS4xODQgMy42MTMtMS43MkMyMS42OTUgNy45IDI0LjE5NSAyLjc2NyAyMS42NzguNTIxbS0xOC41NzMuNTQzQTEuODQyIDEuODQyIDAgMCAwIDEuMjcgMi45djE2LjYwOGExLjg0IDEuODQgMCAwIDAgMS44MzUgMS44MzRoOS40MThhMjIuOTUzIDIyLjk1MyAwIDAgMS0uMDUyLTIuNzA3Yy0uMDA2LS4wNjItLjAxMS0uMTQxLS4wMTYtLjJhMjcuMDEgMjcuMDEgMCAwIDAtLjQ3My0yLjM3OGMtLjEyMS0uNDctLjI3NS0uODk4LS4zNjktMS4wNTctLjExNi0uMTk3LS4wOTgtLjMxLS4wOTctLjQzMiAwLS4xMi4wMTUtLjI0NS4wMzctLjM4NmE5Ljk4IDkuOTggMCAwIDEgLjIzNC0xLjA0NWwuMjE3LS4wMjhjLS4wMTctLjAzNS0uMDE0LS4wNjUtLjAzMS0uMDk3bC0uMDQxLS4zODFhMzIuOCAzMi44IDAgMCAxIC4zODItMS4xOTRsLjItLjAxOWMtLjAwOC0uMDE2LS4wMS0uMDM4LS4wMTgtLjA1M2wtLjA0My0uMzE2Yy42My0zLjI4IDIuNTg3LTcuNDQzIDQuOC05Ljc5MS4wNjYtLjA2OS4xMzMtLjEyOC4xOTgtLjE5NFoiLz48L3N2Zz4="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 375,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 290
  }, "sqlite"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 290
  }, "sqlite"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlite);
export default __webpack_public_path__ + "static/media/sqlite.e02972cb85fd1754afb56820b2d053f5.svg";
export { ForwardRef as ReactComponent };